import * as React from 'react';
import { st, classes } from './CoreDivider.st.css';
/**
 * Divider
 */
export const CoreDivider = (props) => {
    const { children, vertical } = props;
    const customDivider = !!children;
    return (React.createElement("div", { className: st(classes.root, { vertical: vertical && !customDivider, customDivider }, props.className), "data-hook": props['data-hook'] }, children));
};
CoreDivider.displayName = 'CoreDivider';
//# sourceMappingURL=CoreDivider.js.map